/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getActivitySearchDataCheckSample} from '../api'

 export const useQueryGetActivitySearchDataCheckSample = createReactQueryHook('getActivitySearchDataCheckSample', getActivitySearchDataCheckSample)
